import { isEmpty, values } from 'lodash';

export const getScarcityFlag = (units) =>
	isEmpty(units)
		? false
		: values(units).some(
				(unit) => unit.quantity !== null && unit.quantity < 4,
			);
